import * as React from 'react';
import { Translate } from 'react-redux-i18n';

import { FileError } from '../../../../../../containers/ImportManager/actions';
import { Wrapper, Inner, Label } from './styles';

interface ProgressBarProps {
	percentage: number;
	error?: FileError;
}

const getMessage = (percentage: number, error?: FileError): JSX.Element => {
	if (!error) {
		return (
			<Translate
				value="messages.importing_with_percentage"
				percentage={percentage.toString()}
			/>
		);
	}

	return (
		<Translate value="error.file_import_error_short" />
	);
};

const ProgressBar = ({ percentage, error }: ProgressBarProps) => (
	<Wrapper isError={!!error}>
		<Inner
			width={percentage}
			isError={!!error}
		/>
		<Label>{getMessage(percentage, error)}</Label>
	</Wrapper>
);

export default ProgressBar;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/EditPanel/SliderManager/Slide/ProgressBar/index.tsx